var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkin-panel" },
    [
      _c("vx-card", { staticClass: "mb-base" }, [
        _c("div", { staticClass: "cp-header" }, [
          _c("div", [
            _c("h4", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.itemName || "Check-in do evento")),
            ]),
            _c("small", { staticClass: "cp-muted" }, [
              _vm._v(_vm._s(_vm.typeLabel)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "cp-header__actions" },
            [
              _c(
                "label",
                { staticClass: "cp-muted mr-2", attrs: { for: "cp-date" } },
                [_vm._v("Dia")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.date,
                    expression: "date",
                  },
                ],
                staticClass: "cp-date",
                attrs: { id: "cp-date", type: "date" },
                domProps: { value: _vm.date },
                on: {
                  change: _vm.reload,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.date = $event.target.value
                  },
                },
              }),
              _c(
                "vs-button",
                {
                  staticClass: "ml-2",
                  attrs: { size: "small", type: "border" },
                  on: { click: _vm.reload },
                },
                [_vm._v("Atualizar")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "vx-row mb-base" },
        _vm._l(_vm.metrics, function (metric) {
          return _c(
            "div",
            {
              key: metric.label,
              staticClass: "vx-col w-1/2 md:w-1/5 mb-4 md:mb-0",
            },
            [
              _c("vx-card", { staticClass: "cp-metric" }, [
                _c("div", { staticClass: "cp-metric__value" }, [
                  _vm._v(_vm._s(metric.value)),
                ]),
                _c("div", { staticClass: "cp-metric__label" }, [
                  _vm._v(_vm._s(metric.label)),
                ]),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full lg:w-2/3 mb-base" },
          [
            _c("vx-card", { attrs: { title: "Entradas do dia" } }, [
              _vm.loading
                ? _c("p", { staticClass: "cp-muted mb-0" }, [
                    _vm._v("Carregando..."),
                  ])
                : !_vm.entries.length
                ? _c("p", { staticClass: "cp-muted mb-0" }, [
                    _vm._v(" Nenhuma entrada registrada neste dia. "),
                  ])
                : _c("table", { staticClass: "cp-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Pessoa")]),
                        _c("th", [_vm._v("Hora")]),
                        _c("th", [_vm._v("Canal")]),
                        _c("th", [_vm._v("Validado por")]),
                        _c("th"),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.entries, function (entry) {
                        return _c(
                          "tr",
                          {
                            key: entry.id,
                            class: { "cp-row--undone": entry.undone_at },
                          },
                          [
                            _c("td", [
                              _vm._v(" " + _vm._s(entry.holder) + " "),
                              entry.ticket_code
                                ? _c(
                                    "div",
                                    { staticClass: "cp-muted cp-code" },
                                    [_vm._v(_vm._s(entry.ticket_code))]
                                  )
                                : _vm._e(),
                            ]),
                            _c("td", { staticClass: "cp-num" }, [
                              _vm._v(_vm._s((entry.at || "").slice(11, 16))),
                            ]),
                            _c("td", [_vm._v(_vm._s(entry.channel_label))]),
                            _c("td", [_vm._v(_vm._s(entry.validated_by))]),
                            _c("td", { staticClass: "cp-actions" }, [
                              !entry.undone_at
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "cp-link",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.undo(entry)
                                        },
                                      },
                                    },
                                    [_vm._v(" Desfazer ")]
                                  )
                                : _c("span", { staticClass: "cp-muted" }, [
                                    _vm._v("desfeita"),
                                  ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col w-full lg:w-1/3 mb-base" },
          [
            _c("vx-card", { attrs: { title: "Validadores" } }, [
              _c("p", { staticClass: "cp-muted" }, [
                _vm._v(
                  " Quem pode validar ingresso deste evento na portaria. Quem responde pelo estabelecimento já valida sem estar nesta lista. "
                ),
              ]),
              _vm.canManage
                ? _c(
                    "div",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "cp-label",
                          attrs: { for: "cp-validator-term" },
                        },
                        [_vm._v("Nome ou e-mail")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.term,
                            expression: "term",
                          },
                        ],
                        staticClass: "cp-input",
                        attrs: {
                          id: "cp-validator-term",
                          type: "text",
                          autocomplete: "off",
                          placeholder: "ana@clube.com.br",
                        },
                        domProps: { value: _vm.term },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.term = $event.target.value
                            },
                            _vm.onTermInput,
                          ],
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.addValidator.apply(null, arguments)
                          },
                        },
                      }),
                      _vm.searching
                        ? _c("p", { staticClass: "cp-muted mt-1 mb-0" }, [
                            _vm._v("Procurando..."),
                          ])
                        : _vm.candidates.length
                        ? _c(
                            "ul",
                            { staticClass: "cp-candidates" },
                            _vm._l(_vm.candidates, function (candidate) {
                              return _c("li", { key: candidate.id }, [
                                _c(
                                  "button",
                                  {
                                    class: [
                                      "cp-candidate",
                                      {
                                        "cp-candidate--on":
                                          _vm.picked &&
                                          _vm.picked.id === candidate.id,
                                      },
                                    ],
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.pick(candidate)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "cp-list__name" },
                                      [_vm._v(_vm._s(candidate.name))]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "cp-muted cp-list__meta" },
                                      [_vm._v(_vm._s(candidate.email))]
                                    ),
                                  ]
                                ),
                              ])
                            }),
                            0
                          )
                        : _vm.searched && _vm.isEmail
                        ? _c("p", { staticClass: "cp-invite mt-1 mb-0" }, [
                            _vm._v(
                              " Ninguém com este e-mail ainda. Dá para convidar: a pessoa recebe o link, cria a conta dela e o acesso é liberado sozinho. "
                            ),
                          ])
                        : _vm.searched
                        ? _c("p", { staticClass: "cp-muted mt-1 mb-0" }, [
                            _vm._v(" Nenhuma pessoa encontrada. Digite o "),
                            _c("strong", [_vm._v("e-mail completo")]),
                            _vm._v(" para convidar alguém de fora. "),
                          ])
                        : _vm._e(),
                      _vm.searched && _vm.isEmail && !_vm.candidates.length
                        ? _c("div", { staticClass: "mt-2" }, [
                            _c(
                              "label",
                              {
                                staticClass: "cp-label",
                                attrs: { for: "cp-validator-name" },
                              },
                              [_vm._v("Nome (opcional)")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inviteName,
                                  expression: "inviteName",
                                },
                              ],
                              staticClass: "cp-input",
                              attrs: {
                                id: "cp-validator-name",
                                type: "text",
                                autocomplete: "off",
                                placeholder:
                                  "Como chamar esta pessoa no convite",
                              },
                              domProps: { value: _vm.inviteName },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inviteName = $event.target.value
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm.canSubmit
                        ? _c("label", { staticClass: "cp-checkbox mt-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.applyToAll,
                                  expression: "applyToAll",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.applyToAll)
                                  ? _vm._i(_vm.applyToAll, null) > -1
                                  : _vm.applyToAll,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.applyToAll,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.applyToAll = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.applyToAll = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.applyToAll = $$c
                                  }
                                },
                              },
                            }),
                            _c("span", [
                              _vm._v(
                                "Validar em todos os meus eventos com ingresso"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "vs-button",
                        {
                          staticClass: "mt-2 w-full",
                          attrs: {
                            size: "small",
                            disabled: !_vm.canSubmit || _vm.adding,
                          },
                          on: { click: _vm.addValidator },
                        },
                        [_vm._v(" " + _vm._s(_vm.submitLabel) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "ul",
                { staticClass: "cp-list" },
                [
                  _vm._l(_vm.validators, function (validator) {
                    return _c(
                      "li",
                      { key: validator.id, staticClass: "cp-list__item" },
                      [
                        _c("div", { staticClass: "cp-list__who" }, [
                          _c("div", { staticClass: "cp-list__name" }, [
                            _vm._v(
                              " " +
                                _vm._s(validator.name || validator.email) +
                                " "
                            ),
                            validator.pending
                              ? _c("span", { staticClass: "cp-badge" }, [
                                  _vm._v("convite enviado"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "cp-muted cp-list__meta" }, [
                            _vm._v(_vm._s(validator.email)),
                          ]),
                          validator.pending
                            ? _c(
                                "div",
                                { staticClass: "cp-muted cp-list__meta" },
                                [
                                  _vm._v(
                                    " Vale assim que a pessoa criar a conta com este e-mail. "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm.canManage
                          ? _c(
                              "button",
                              {
                                staticClass: "cp-link cp-link--danger",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeValidator(validator)
                                  },
                                },
                              },
                              [_vm._v(" Remover ")]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  !_vm.validators.length
                    ? _c("li", { staticClass: "cp-muted" }, [
                        _vm._v("Nenhum validador designado."),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }